import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Endereco } from '../modelo/endereco';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { EnderecoService } from '../services/endereco.service';
import { Contrato } from '../modelo/contrato';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnderecoLogradouro } from '../modelo/enderecoLogradouro';
import { SelectItem } from '../modelo/selectItem';
import { Estado } from '../enumaration/estado';
import { Config } from '../services/config';
import { EnderecoCep } from '../modelo/enderecoCep';
import { Cep } from '../modelo/cep';

declare var $ :any;

@Component({
  selector: 'app-endereco-modal-busca',
  templateUrl: './endereco-modal-busca.component.html',
  styleUrls: ['./endereco.component.css'],
  providers: [EnderecoService, MensagemService, RestClientService]
})
export class EnderecoModalBuscaComponent extends AbstractComponent implements OnInit {

  dsCidade: string = '';
  cdUf: string = '';
  cdCep: string = '';
  dsEndereco: string = '';
  estadoList: SelectItem[];
  eCep: EnderecoCep = new EnderecoCep();

  logradouroList: EnderecoLogradouro = new EnderecoLogradouro();
  logradouroList2: EnderecoLogradouro = new EnderecoLogradouro();
  cepList: EnderecoLogradouro = new EnderecoLogradouro();

  constructor(
    private enderecoService: EnderecoService,
    private mensagemService: MensagemService,
    private router: Router,
    private sessaoService: SessaoService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EnderecoModalBuscaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);

    // Cria combo de estado
    this.estadoList = Estado.values();
  }

  /**
   * Método chamado na inicialização
   */
  ngOnInit() {
    $('ul.tabs').tabs();
    setTimeout(function () {
      $('.cdk-global-overlay-wrapper').css({ 'align-items': "flex-end" });
    }, 0);
  }

  /**
   * Esconde as buscas ao trocar de aba
   */
  changeTab(){
    $('.buscaCep').hide();
    $('.buscaEndereco').hide();
    $('.buscaCidade').hide();
  }

  /**
   * Realiza a busca do endereço pelo cep digitado na tela
   */
  buscarCep() {
    if(!this.validaAbaCep()){
      this.mensagemService.show(this.campos);
      return;
    }
    this.enderecoService.consultarEndereco(this.cdCep).subscribe(
      (result: Cep) => {
        if (result.cdMsgemRetorno == 0) {
          this.eCep = result.listaEndereco[0];
          $('.buscaCep').slideDown('fast');
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
          $('.buscaCep').hide();
        }
        this.cdCep='';
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Realiza a busca de cidades
   */
  buscarCidade() {
    if(!this.validaAbaCidade()) {
      this.mensagemService.show(this.campos);
      return;
    }
    this.enderecoService.consultarEnderecoPorCidade(this.cdUf, this.dsCidade).subscribe(
      (result: EnderecoLogradouro) => {
        if(result.cdMsgemRetorno == "0"){
          this.cepList = result;
          $('.buscaCidade').slideDown('fast');
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
          $('.buscaCidade').hide();
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Realiza a busca por endereço digitado
   */
  buscarEndereco() {
    if(!this.validaAbaEndereco()){
      this.mensagemService.show(this.campos);
      return;
    }
    this.enderecoService.consultarEnderecoPorLogradouro(this.dsEndereco, this.cdUf).subscribe(
      (result: EnderecoLogradouro) => {
        if(result.cdMsgemRetorno == "0"){
          this.logradouroList = result;
          $('.buscaEndereco').slideDown('fast');
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
          $('.buscaEndereco').hide();
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Exibe os endereços de acordo com a cidade selecionada
   */
  selectCidade(dsCidade: string) {
    this.enderecoService.consultarEnderecoPorLogradouro2(this.dsEndereco, this.cdUf, dsCidade).subscribe(
      (result: EnderecoLogradouro) => {
        if(result.cdMsgemRetorno == "0"){
          this.logradouroList2 = result;
          $('.selectCidade').slideDown('fast');
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
          $('.selectCidade').hide();
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Fecha a popup após a seleção do endereço
   */
  selecionaEndereco(enderecoCep: EnderecoCep){
    $('.buscaCep').hide();
    $('.buscaEndereco').hide();
    $('.buscaCidade').hide();
    this.dialogRef.close(enderecoCep);
  }

  /**
   * Fecha a modal
   */
  fechar() {
    $('.buscaCep').hide();
    $('.buscaEndereco').hide();
    $('.buscaCidade').hide();
    this.dialogRef.close();
  }

  /**
   * Validação da aba Endereço
   */
  validaAbaEndereco(): boolean {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;
    if(this.dsEndereco == null || this.dsEndereco.trim() == ""){
      this.campos.push("endereco");
      isValid = false;
    }
    if(this.cdUf == null || this.cdUf.trim() == ""){
      this.campos.push("estado");
      isValid = false;
    }

    return isValid;
  }

  /**
   * Validação da aba Cidade
   */
  validaAbaCidade(): boolean {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;
    if(this.dsCidade == null || this.dsCidade.trim() == ""){
      this.campos.push("cidade");
      isValid = false;
    }
    if(this.cdUf == null || this.cdUf.trim() == ""){
      this.campos.push("estado2");
      isValid = false;
    }

    return isValid;
  }

  /**
   * Validação da aba Cep
   */
  validaAbaCep(): boolean {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;
    if(this.cdCep == null || this.cdCep.trim() == ""){
      this.campos.push("cep");
      isValid = false;
    }

    return isValid;
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-endereco-cli/endereco-modal-busca.component.ts